import type { SortingStrategy } from "@dnd-kit/sortable"

// The nav marks the drop position with an insertion line, so rows must not
// also slide apart. Two indicators disagreeing is what made the line jitter,
// and static rows keep every measured rect valid for the whole drag.
export const noSortShift: SortingStrategy = () => null
